import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BusinessType, FeatureName, UserRole } from '@wephone-core/system';
import { SmsSentComponent } from './component';

const routes: Routes = [
  {
    path: 'sent',
    component: SmsSentComponent,
    data: {
      expectedRoles: [UserRole.ADMIN, UserRole.SUPERVISOR, UserRole.WATCHER, UserRole.AGENT],
      expectedBusinessTypes: [BusinessType.CALLCENTER, BusinessType.HOTEL, BusinessType.ENTERPRISE, BusinessType.SIPTRUNK],
      expectedFeatures: [FeatureName.SMS],
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WephoneSmsRoutingModule { }
